import { Button } from "antd";
import Style from "./style";

const CustomButton = ({
  children,
  ...props
}) => {
  return (
    <Style className="d-btn-cont">
      <Button {...props}>
        {children}
      </Button>
    </Style>
  )
};

export default CustomButton;
